import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

function ManualNull({ setTutorial }) {
  const handleOnClick = () => {
    setTutorial("null");
  };

  return (
    <div className={`${styles["foreground"]} ${styles["foreground-0"]}  ${styles["overlay"]}`}>
      <ButtonTomatoClose onClick={handleOnClick} />
      <div className={styles["header"]}>
        <div className={styles["header__assistant"]}></div>
        <div className={styles["header__text--main"]}>
          <p>To run a manual tutorial, the function should not contain any parameters.</p>
        </div>
      </div>
      <div className={styles["confirmation"]}>
        <ButtonIntroWide theme="tomato" title="Got it!" onClick={handleOnClick} />
      </div>
    </div>
  );
}

export default ManualNull;
